import { render, staticRenderFns } from "./Kiosk.vue?vue&type=template&id=c03d1eae&"
import script from "./Kiosk.vue?vue&type=script&lang=js&"
export * from "./Kiosk.vue?vue&type=script&lang=js&"
import style0 from "./Kiosk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports